import Marquee from "react-fast-marquee";
import { brandLogos } from "../../assets/dummyData";
import { Box } from "@mui/material";

const BrandLogoSlider = () => {
  return (
    <Box
      sx={{
        borderRadius: "20px",
        backgroundColor: "#fff",
        boxShadow: "-1px -2px 15px 0px #00000012",
        mx: 2,
        mb: 2,
      }}
    >
      <Marquee gradient={false} speed={50} pauseOnHover={true} direction="left">
        {brandLogos.map((logo, i) => (
          <Box key={i} sx={{ mx: 2, display: "inline-block" }}>
            <img
              src={logo}
              alt="brand"
              style={{ width: "120px", height: "60px", objectFit: "contain" }}
            />
          </Box>
        ))}
      </Marquee>
    </Box>
  );
};

export default BrandLogoSlider;
